<template>
  <svg
    :width="width ? width : height ? height * (15 / 9) : 15"
    :height="height ? height : width ? width * (9 / 15) : 9"
    viewBox="0 0 15 9"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="Detalje-2b---Foldet-ud"
        transform="translate(-448.000000, -274.000000)"
        :stroke="iconColor"
        stroke-width="2"
      >
        <polyline
          id="Path-4"
          transform="translate(455.476872, 278.235670) rotate(-180.000000) translate(-455.476872, -278.235670) "
          points="449.690995 275.342731 455.476872 281.128608 461.262748 275.342731"
        ></polyline>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'chevron-up',
  props: {
    iconColor: {
      type: String,
      default: '#FFF',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
